import { httpRequest } from "@services/http";
import { Contract } from "@models/contract.model";
import { ContractSerializer } from "@models/serializers/contractSerializer";

export interface UpdateContractPayload {
  name?: string | null;
  billing_method?: string | null;
  // MPN-1530 §4.2. Together these define the subscription's billing cycle.
  billing_amount?: number | null;
  billing_frequency?: string;
  po?: string | null;
  contract_url?: string | null;
  contract_start_date?: string | null;
  contract_end_date?: string | null;
  products?: string[];
  revenue_cap?: number | null;
  max_list_size?: number | null;
  sized_by?: string | null;
  list_type?: string | null;
  /** The vertical's journey (MPN-1573). Omit to leave unchanged; null clears it. */
  journey_id?: number | null;
  is_active?: boolean;
}

export class CommandUpdateContract {
  async run(contractId: number, payload: UpdateContractPayload): Promise<Contract> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return ContractSerializer.fromJson(response);
  }
}
